import Tag from "./TagComponent";

export default Tag;
